import { PAYMENTS } from "./types"

const fetchNetwork = () => ({
    type: PAYMENTS.FETCH_NETWORK,
});

const fetchNetworkSuccess = data => ({
    type: PAYMENTS.FETCH_NETWORK_SUCCESS,
    payload: data
});

const buyAirtime = (data,history) => ({
    type: PAYMENTS.BUY_AIRTIME,
    payload: data,
    history
});

const fetchDataProvider = () => ({
    type: PAYMENTS.FETCH_DATA_PROVIDER,
});

const fetchDataProviderSuccess = data => ({
    type: PAYMENTS.FETCH_DATA_PROVIDER_SUCCESS,
    payload: data
});

const fetchDataSubscription = (data) => ({
    type: PAYMENTS.FETCH_DATA_SUBSCRIPTION,
    payload: data
});

const fetchDataSubscriptionSuccess = data => ({
    type: PAYMENTS.FETCH_DATA_SUBSCRIPTION_SUCCESS,
    payload: data,
});

const buyData = (data, history) => ({
    type: PAYMENTS.BUY_DATA,
    payload: data,
    history
});

const fetchTvProviders = () => ({
    type: PAYMENTS.FETCH_TV_PROVIDERS,
});

const fetchTvProvidersSuccess = data => ({
    type: PAYMENTS.FETCH_TV_PROVIDERS_SUCCESS,
    payload: data
});

const fetchTvSubscription = data => ({
    type: PAYMENTS.FETCH_TV_SUBSCRIPTIONS,
    payload: data
});

const fetchTvSubscriptionSuccess = data => ({
    type: PAYMENTS.FETCH_TV_SUBSCRIPTIONS_SUCCESS,
    payload: data
});

const verifyCard = (data, history) => ({
    type: PAYMENTS.VERIFY_CARD,
    payload: data,
    history
});

const buyTvSub = (data, history) => ({
    type: PAYMENTS.BUY_TV_SUB,
    payload: data,
    history
})

const fetchElectricitySub = () => ({
    type: PAYMENTS.FETCH_ELECTRICITY_SUB,
})

const fetchElectricitySubSuccess = data => ({
    type: PAYMENTS.FETCH_ELECTRICITY_SUB_SUCCESS,
    payload: data
})

const verifyMeterNumber = (data, history) => ({
    type: PAYMENTS.VERIFY_METER_NUMBER,
    payload: data,
    history
})

const buyElectricitySub = (data, history) => ({
    type: PAYMENTS.BUY_ELECTRICITY_SUB,
    payload: data,
    history
})

export {
    fetchNetwork,
    fetchNetworkSuccess,
    buyAirtime,
    fetchDataProvider,
    fetchDataProviderSuccess,
    fetchDataSubscriptionSuccess,
    fetchDataSubscription,
    buyData,
    fetchTvProviders,
    fetchTvProvidersSuccess,
    fetchTvSubscription,
    fetchTvSubscriptionSuccess,
    verifyCard,
    buyTvSub,
    fetchElectricitySub,
    verifyMeterNumber,
    buyElectricitySub,
    fetchElectricitySubSuccess
};